<div class="flex items-center tooltip-styling" [ngStyle]="{'color': getColor(element[tableColumn.dataKey])}"
[matTooltip]=" element[tableColumn.dataKey]? ((element[tableColumn.dataKey]))  : '/'">
  <div class="w-3 h-3 rounded-full mr-2"
     [ngStyle]="{'background-color': getColor(element[tableColumn.dataKey])}"></div>

     {{ element[tableColumn.dataKey]? (element[tableColumn.dataKey]) :
        '/'}}
</div>
